import { useState } from "react";
import { Link } from "react-router-dom";
import TitleCard from "@/components/feature/TitleCard";
import { titles } from "@/mocks/titles";

const tabs = [
  { value: "all", label: "全部推荐" },
  { value: "movie", label: "最新电影" },
  { value: "tv", label: "热播剧集" },
] as const;

type TabValue = (typeof tabs)[number]["value"];

export default function LatestRecommend() {
  const [tab, setTab] = useState<TabValue>("all");

  const list = titles
    .filter((item) => (tab === "all" ? true : item.type === tab))
    .sort((a, b) => b.year - a.year || b.rating - a.rating)
    .slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 md:mb-8">
          <div>
            <span className="text-xs tracking-[0.22em] uppercase text-secondary-600">Editor&apos;s Picks</span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mt-2">最新影视推荐</h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-xl">本周新上线与持续口碑发酵的作品，选择困难的时候，从这里挑一部。</p>
          </div>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 self-start md:self-auto">
            {tabs.map((item) => (
              <button
                key={item.value}
                type="button"
                onClick={() => setTab(item.value)}
                className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  tab === item.value
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-700"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {list.map((item) => (
            <TitleCard key={item.id} title={item} />
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to={tab === "tv" ? "/category?type=tv" : tab === "movie" ? "/category?type=movie" : "/category"}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多作品
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}